module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Font-091f650a39ecfec0c1886d1a49dabe63426caba7103cf712f2c495455548ea54.svg";